import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SelfPickupsDialogService} from "../../services/self-pickups-dialog.service";
import {SelfPickupsService} from "../../services/self-pickups-service.service";
import {DateRangeTimeFiltersService} from "../../../commons/services/date-range-time-filters.service";

export class selfPickupsViewCtrl implements IController {

  depot: any;
  isActiveView: boolean;

  private allStatusesRef: any;
  private loading: any;
  private reloadList: boolean;
  private selectedSelfPickup: any;
  private statusOptions: any;
  private selectedStatuses: any;

  private selfPickupsToAdd: any;
  private totalCount: number;
  private filterConfig: any;

  /* @ngInject */
  constructor(private selfPickupsConstants, private selfPickupsDialogService: SelfPickupsDialogService, private $state, private moment,
              private selfPickupsService: SelfPickupsService, private dateRangeTimeFiltersService: DateRangeTimeFiltersService, private $log) {
  }

  $onInit() {
    this.allStatusesRef = this.isActiveView ?
      this.selfPickupsConstants.activeStatuses :
      this.selfPickupsConstants.inActiveStatuses;

    this.loading = {
      totals: false
    };
    this.reloadList = false;
    this.selectedSelfPickup = undefined;

    this.statusOptions = this.allStatusesRef;
    this.selectedStatuses = this.allStatusesRef;
    this.selfPickupsToAdd = [];
    this.totalCount = 0;

    this.filterConfig = {
      customTemplates: this.dateRangeTimeFiltersService.getDeliveriesCustomTemplates(),
      range: {dateStart: undefined, dateEnd: undefined}
    };

    if (!this.isActiveView) {
      this.filterConfig.range = {
        dateStart: this.moment().startOf('day').valueOf(),
        dateEnd: this.moment().endOf('day').valueOf()
      }
    }

    this._getTotals(this.depot.id, this.filterConfig.range.dateStart, this.filterConfig.range.dateEnd);
  };

  // ******************************
  //        Public methods
  // ******************************

  onDepotSelect(depot) {
    this.depot = depot;
    this.$state.go('.', {depotId: _.get(depot, 'id')}, {notify: false, reload: false, location: 'replace'});
  }

  onChangeQueryStatus(status) {
    this.selectedStatuses = status ? [status] : this.allStatusesRef;
    this.selectedSelfPickup = undefined;
    this._getTotals(this.depot.id, this.filterConfig.range.dateStart, this.filterConfig.range.dateEnd);
  }

  onRangeChanged(range) {
    this.filterConfig.range = range;
    this.reloadList = true;
    this._getTotals(this.depot.id, range.dateStart, range.dateEnd);
  }

  onSelectSelfPickup(selfPickup) {
    this.selectedSelfPickup = _.isEqual(_.get(this.selectedSelfPickup, 'id'), selfPickup.id)
      ? undefined : selfPickup;
  }

  isActiveSelfPickup(selfPickup) {
    return _.includes(this.selfPickupsConstants.activeStatuses, _.get(selfPickup, 'status'))
  }

  onCreateSelfPickup($event) {
    this.selfPickupsDialogService.createOne(this.depot, $event)
      .then((selfPickupToCreate) => {
        this._createSelfPickup(selfPickupToCreate);
      })
  }

  onChangeSelfPickupStatus(selfPickup, status) {
    const selfPickupCopy = angular.copy(selfPickup);
    selfPickupCopy.status = status;

    if (status === 'Completed') {
      this.selfPickupsDialogService.signature(event)
        .then((payload) => {
          if (payload) {
            selfPickupCopy.identifications = {
              signatureUrl: payload.signatureUrl,
              signerName: payload.signerName
            };
          }
          this._updateSelfPickup(selfPickupCopy);
        })
        .catch(() => {
          this.$log.info('Dialog Closed');
        })
    } else {
      selfPickupCopy.identifications = undefined;
      this._updateSelfPickup(selfPickupCopy);
    }
  }

  onEditSelfPickup(selfPickup, $event) {
    this.selfPickupsDialogService.editOne(selfPickup, this.depot, $event)
      .then((editedSelfPickup) => {
        this._updateSelfPickup(editedSelfPickup);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onAddPackaging(selfPickup, $event) {
    this.selfPickupsDialogService.moveToReady(selfPickup.packages, selfPickup.contact, selfPickup.id, $event)
      .then((result) => {
        const editedSelfPickup = angular.copy(selfPickup);
        editedSelfPickup.packages = result.packages;
        editedSelfPickup.status = result.status;

        this._updateSelfPickup(editedSelfPickup);
      })
      .catch(() => {
        this.$log.info('Dialog Closed');
      })
  }

  onSendMessage(selfPickup) {
    this.selfPickupsService.sendMessage(selfPickup.id)
      .then((response) => {
      })
  }

  onPrint(selfPickup) {

  }

  // ******************************
  //        Private methods
  // ******************************

  _createSelfPickup(selfPickup) {
    this.selfPickupsService.createOne(selfPickup)
      .then((createdSelfPickup) => {
        this.selfPickupsToAdd = [createdSelfPickup];
        this._getTotals(this.depot.id, this.filterConfig.range.dateStart, this.filterConfig.range.dateEnd);
      })
  }

  _updateSelfPickup(selfPickup: any) {
    this.selfPickupsService.updateOne(selfPickup.id, selfPickup)
      .then((updatedSelfPickup: any) => {
        if (this.selectedSelfPickup && this.selectedSelfPickup.id === updatedSelfPickup.id) {
          this.selectedSelfPickup = updatedSelfPickup;
        }
      })
  }

  _getTotals(depotId, from, to) {
    this.loading.totals = true;
    this.selfPickupsService.getTotals(depotId, from, to)
      .then((totals: any) => {
        this.totalCount = _.chain(totals)
          .filter((t) => {
            return _.includes(this.allStatusesRef, t.status);
          })
          .sumBy((filteredTotal) => {
            return filteredTotal.count || 0;
          })
          .value();
      })
      .finally(() => {
        this.loading.totals = false;
      })
  }

}

angular
  .module('bringoz.admin.self-pickups')
  .component('selfPickupsView', {
    bindings: {
      depot: '<',
      isActiveView: '<'
    },
    template: require('./self-pickups-view.html').default,
    controller: selfPickupsViewCtrl
  });
